import Vue from 'vue'
import resetData from "./reset_data.js"
import tools from "@/public/tools.js"
export default {
	setaside_param(state,arg){
		Vue.set(state.aside_param,arg.key,arg.value);
	},
	//設置關聯
	setQuoteRelation(state,arg){
		if(arg){
			//選擇
			state.relation = arg;
		}else{
			//取消選擇
			state.relation = "";
		}
	},
	//setQuoteLoading
	setQuoteLoading(state,arg){
		state.quoteLoading = arg;
	},
	resetQuoteParams(state){
		//初始化數據  點擊reset的時候也會重置此參數，所有計價都會被重置
		for(let k in resetData){
			if(state[k] && (typeof state[k] === "object")){
				state[k] = tools.deepCopy(resetData[k]);
			}else{
				state[k] = resetData[k]
			}
		}
		//根據國家設置計價初始國家
	},
	//提交参数只有一个层级
	setQuoteOneParams(state,data){
		let value = data.value,key = data.key;
		Vue.set(state,key,value);
	},
	//修改提交參數 通用
	setQuoteParams(state,data){
		let value = data.value,keys = data.key.split(".");
		let key1 = keys[0],key2 =  keys[1];
		Vue.set(state[key1],key2,value);
	},
	//删除提交参数 通用
	deleteQuoteParams(state,data){
		let keys = data.key.split(".");
		let key1 = keys[0],key2 =  keys[1];
		delete state[key1][key2]
	},
	//設置獲取到的物流數據
	setQuoteExpressList(state,arg){
		state.expressList = arg;
		if(arg.length){
			let express = state.aside_param.express;
			for(let i = 0;i<arg.length;i++){
				if(arg[i].shipping_id == express){
					state.aside_param.expresstime = arg[i].shipping_time;
					break;
				}
			}
		}
	},
	//設置獲取到的計價數據
	setQuoteValuation(state,arg){
		//后台未返回前，前端处理优惠特价等逻辑
		state.valuation = tools.setValuationData(arg);
	},
	// 清空SMT价钱和bom价钱
	resetSmtAndBomPrice(state,arg){
		const { pcb_total } = state.valuation
		state.valuation = { pcb_total } //tools.setValuationData(arg);
	},
	setQuoteArea(state,arg){
		state.area = arg.value;
	},
	//設置是否可提交計價狀態
	setQuoteStatus(state,arg){
		Vue.set(state.canQuote,arg.key,arg.value);
	},
	setQuoteBtnclick(state,arg){
		state.isCalcBtn = arg;
	},
	setAjaxQuoteParams(state,vars){
		state.ajaxQuoteParams = vars;
	},
	setsmtQuoteOn(state,arg){
		state.smtQuoteOn = arg;
	},
	//设置smt活动
	setIsSmtActivity(state, value){
		state.isSmtActivity=value
	}, 

	//设置是否正在计价中
	setIsValuationing(state, value){
		state.isValuationing=value
	},

	//设置文件解析ID
	setAnalyseId(state, value){
		state.analyseId=value
	},
	
	// 设置阶梯价格
	setStepPrice(state, value){
		state.stepPrice = value
	},

	// 设置是否阶梯价格点击
	setIsStepClick(state, value){
		state.isStepClick = value
	},

	// 设置是否阶梯价格点击
	setIsLoadingStep(state, value){
		state.isLoadingStepPrice = value
	},

	// 设置加购时需要检查的字段提示
	setParamsCheck(state, {key, value}){
		Vue.set(state.paramsCheck, key, value)
	},

	// 设置是否是系统自动计算
	setIsSystemQuote(state, value){
		state.isSystemQuote = value
	},

	// 设置PCB文件是否解析成功
	setAnalyzeSuccess(state, value) {
		state.analyzeSuccess = value
	},

	// 设置PCB文件是否修改
	setGerberFileIsChange(state, value) {
		state.gerberFileIsChange = value
	}
	
}